import type { ImprintLogoFormat, ImprintLogoVariant } from "@/types/domain"

export const imprintLogoVariants: Array<{ variant: ImprintLogoVariant; label: string; description: string; previewBackground: "light" | "dark" | "white" | "black" }> = [
  { variant: "AVATAR_COLOR", label: "Avatar colorido", description: "Nas cores principais da marca.", previewBackground: "light" },
  { variant: "AVATAR_MONO", label: "Avatar P&B", description: "Preto sobre fundo branco.", previewBackground: "white" },
  { variant: "LOGO_COLOR_LIGHT", label: "Logo principal colorido", description: "Para fundo claro.", previewBackground: "light" },
  { variant: "LOGO_COLOR_DARK", label: "Logo principal colorido", description: "Para fundo escuro.", previewBackground: "dark" },
  { variant: "LOGO_MONO_WHITE", label: "Logo principal P&B", description: "Para fundo branco.", previewBackground: "white" },
  { variant: "LOGO_MONO_BLACK", label: "Logo principal P&B", description: "Para fundo preto.", previewBackground: "black" },
]

export const imprintLogoFormats: ImprintLogoFormat[] = ["PNG", "SVG"]

export const imprintLogoMimeTypes: Record<ImprintLogoFormat, string> = { PNG: "image/png", SVG: "image/svg+xml" }

export const imprintLogoMaxBytes = 5_000_000

/** Mensagem de erro para um arquivo de logotipo inválido; `undefined` quando o arquivo é aceito. */
export function imprintLogoFileError(format: ImprintLogoFormat, file: File) {
  const extension = file.name.split(".").pop()?.toLowerCase()
  if (file.type !== imprintLogoMimeTypes[format] || extension !== format.toLowerCase()) return `Envie um arquivo ${format}.`
  if (file.size <= 0 || file.size > imprintLogoMaxBytes) return "O arquivo deve ter no máximo 5 MB."
  return undefined
}
